import {Card, Col, Row} from "react-bootstrap";
import SearchBar from "./SearchBar.ProductSelection";
import {useState} from "react";
import {Avatar, IconButton, TextField} from "@material-ui/core";
import RemoveIcon from "@material-ui/icons/Remove";
import {nanoid} from "@reduxjs/toolkit";

export default function ProductSelection({onChange, items}) {
    const [list, setList] = useState(items ?? [])

    const handleChange = (change) => {
        onChange && onChange(change)
        setList(change)
    }

    const handleSelection = (items) => {
        const format = items.map(item => ({
            ...item,
            Quantity: {
                Ordered: 0,
                Bought: 0
            }
        }));
        handleChange([...list, ...format])
    }

    const handleElementRemoving = (index) => {
        handleChange(list.filter((value, ind) => ind !== index))
    }

    const handleSetQuantity = (index, quantity) => {
        if (quantity >= 0)
            handleChange(list.map((item, ind) => {
                return ind === index ? {...item, Quantity: {Ordered: quantity, Bought: 0}} : item;
            }))
    }

    return (
        <section>
            <h5>Produits</h5>
            <section style={{display: 'grid', placeItems: 'center'}}>

                <Row>
                    <SearchBar onSelection={handleSelection}/>
                </Row>

                <Row>
                    <Col>
                        {
                            list && list.map(({ImageUrl, Name, id, Quantity}, index) => (
                                <Row key={nanoid()} className='p-2'>
                                    <Card style={{width: 700}}>
                                        <Card.Body>
                                            <Row>
                                                <Col className='col-auto'>
                                                    <Avatar src={ImageUrl}/>
                                                </Col>
                                                <Col style={{display: 'grid', placeItems: 'center'}}>
                                                    <b>{Name}</b>
                                                </Col>
                                                <Col className='col-auto ml-auto'>
                                                    <TextField
                                                        label='Quantity'
                                                        type='number'
                                                        value={Quantity.Ordered}
                                                        min={0}
                                                        onChange={event => handleSetQuantity(index, Number(event.target.value))}
                                                    />
                                                </Col>
                                                <Col className='col-auto ml-auto'>
                                                    <IconButton onClick={() => handleElementRemoving(index)}>
                                                        <RemoveIcon color='error'/>
                                                    </IconButton>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>

                                </Row>
                            ))
                        }
                    </Col>

                </Row>
            </section>

        </section>
    )
}
